import { render, staticRenderFns } from "./PagePickup.vue?vue&type=template&id=5301c7b8"
import script from "./PagePickup.vue?vue&type=script&lang=js"
export * from "./PagePickup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports